import * as React from 'react';
import { useTranslation } from 'react-i18next';

const Notification = React.memo(({ id, model, autoClose = true, onDelete, timeToClose = 4000 }) => {

	const { t } = useTranslation();

	const close = React.useCallback(() => {
		onDelete?.(id);
	}, [id, onDelete]);

	React.useEffect(() => {
		if (autoClose) {
			const timeoutId = setTimeout(() => close(), timeToClose);

			return () => {
				clearTimeout(timeoutId);
			};
		}
	}, [autoClose, close, timeToClose]);

	//TODO these shouldn't be translated here since notifications can have custom content.
	const content = React.useMemo(() => {
		if (model.type === 'Achievement') {
			return (
				<div className="achievement" >
					<i className={`achievement-${model.image}`} />
					<div className="points">{model.points}</div>
					<div className="title">{t(model.title)}</div>
					<div className="description" >{t(model.description)}</div>
				</div>
			);
		}

		return (
			<div className="notificationItem">{t(model.message)}</div>
		);
	}, [model, t]);

	return (
		<div className="notification" onClick={close}>
			{content}
		</div>
	);
});

Notification.displayName = 'Notification';

const Notifications = React.forwardRef(({ timeToClose }, ref) => {
	const [toasts, setToasts] = React.useState([]);

	React.useImperativeHandle(ref, () => ({
		createToast(model) {
			setToasts((currentToasts) => [
				...currentToasts,
				{
					id: (Math.random() * 10000000),
					model: model,
				},
			]);

		},
	}));

	const close = React.useCallback((id) => {
		setToasts((currentToasts) =>
			currentToasts.filter((toast) => toast.id !== id),
		);
	}, []);

	return (
		<div className="notifications">
			{toasts.map((item) => (
				<Notification key={item.id} id={item.id} model={item.model} onDelete={close} timeToClose={timeToClose} />
			))}
		</div>
	);
});

Notifications.displayName = 'Notifications';

export default React.memo(Notifications);
